import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import { Container, Row, Column } from '../Grid';
import Share from '../Share';
import OutboundLink from '../OutboundLink';
import Image from '../Image';
import Button from '../Button';
import Icon from '../Icon';
import './styles.scss';

/**
 * A global footer component that is populated with properties from `gatsby-config.js`
 */

const Footer = () => {
  const { site } = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          partnerName
          partnerLogo
          partnerUrl
          programName
          aboutProgram
          menuLinks {
            label
            path
          }
        }
      }
    }
  `);

  const handleBackToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <footer className="footer">
      <div className="footer__top">
        <Container>
          <div className="footer__to_top">
            <button className="footer__to_top-button" onClick={handleBackToTop}>
              Back to Top
              <span className="footer__to_top-icon">
                <Icon name="arrowrightgray" />
              </span>
            </button>
          </div>
          <div className="footer__content">
            <Row>
              <Column size={5}>
                <div className="footer__logos">
                  <OutboundLink
                    to="https://www.discoveryeducation.com"
                    target="_blank"
                    className="footer__de-logo"
                  >
                    <Image
                      filename="de-footer-logo.png"
                      alt="Discovery Education"
                    />
                  </OutboundLink>
                  <div className="footer__logo-divider" />
                  <OutboundLink
                    to="https://www.3m.com"
                    target="_blank"
                    className="footer__3M-logo"
                  >
                    <Image
                      filename="3M-footer-logo.png"
                      alt="Discovery Education"
                    />
                  </OutboundLink>
                </div>
                <div className="footer__about-copy">
                  <p>
                    Discovery Education and 3M created the Young Scientist Lab
                    to provide students from every background with a direct
                    connection to the power of problem-solving. Join us as we
                    encourage students to tackle real-world challenges that are
                    important to them with hands-on learning tools aligned to
                    education standards, plus the nation’s premier middle school
                    science challenge.
                  </p>
                </div>
                <div className="footer__about">
                  <Button to="/about">Learn more</Button>
                </div>
              </Column>
              <Column size={5} offset={2}>
                <h2 className="footer__heading">Stay Connected</h2>
                <p>
                  Stay up to date on latest curriculum additions, virtual field
                  trips and educational materials.
                </p>
                <div className="footer__subscribe-share">
                  <OutboundLink
                    to="https://info.discoveryeducation.com/YoungScientistLab.html"
                    className="button footer__signup-button mr-1"
                  >
                    Sign up for updates
                    <Icon name="mailiconsmall" />
                  </OutboundLink>
                  <Share />
                </div>
                <OutboundLink
                  to="https://twitter.com/hashtag/youngscientist?src=hashtag_click"
                  className="footer__hashtag"
                >
                  #YoungScientist
                </OutboundLink>
              </Column>
            </Row>
          </div>
        </Container>
      </div>
      <div className="footer__base">
        <Container className="footer__base-container" fullWidth>
          <div className="footer__copyright">
            © {new Date().getFullYear()} Discovery Education, Inc.
          </div>
          <div className="footer__base-links">
            <ul className="footer__base-list">
              <li className="footer__base-list-item">
                <OutboundLink
                  to=""
                  className="cookie_settings footer__base-link"
                >
                  Cookie Setting
                </OutboundLink>
              </li>
              <li className="footer__base-list-item">
                <OutboundLink
                  to="https://www.discoveryeducation.com/privacy-policy/"
                  className="footer__base-link"
                >
                  Privacy Policy
                </OutboundLink>
              </li>
              <li className="footer__base-list-item">
                <OutboundLink
                  to="https://www.discoveryeducation.com/terms-of-use/"
                  className="footer__base-link"
                >
                  Terms of Use
                </OutboundLink>
              </li>
              <li className="footer__base-list-item">
                <OutboundLink
                  to="https://www.discoveryeducation.com/help/contact-us/"
                  className="footer__base-link"
                >
                  Contact Us
                </OutboundLink>
              </li>
            </ul>
          </div>
        </Container>
      </div>
    </footer>
  );
};

export default Footer;
